module.exports = __webpack_public_path__ + "img/letter_icon2.5d520985.png";